export default "__VITE_ASSET__Bha9hhGg__"